// import React, { useState } from 'react';
// import { useCookies } from 'react-cookie';

// function CookieConsent() {
//   const [cookies, setCookie] = useCookies(['cookieConsent']);
//   const [showPreferences, setShowPreferences] = useState(false);
//   const [preferences, setPreferences] = useState({
//     marketing: false,
//     analytics: false,
//   });

//   // Agar consent pehle se diya hua hai toh banner mat dikhao
//   if (cookies.cookieConsent) return null;

//   const handleAccept = () => {
//     setCookie('cookieConsent', 'accepted', { path: '/', maxAge: 365 * 24 * 60 * 60 });
//     setCookie('cookiePreferences', { marketing: true, analytics: true }, { path: '/' });
//   };

//   const handleDecline = () => {
//     setCookie('cookieConsent', 'declined', { path: '/', maxAge: 365 * 24 * 60 * 60 });
//     setCookie('cookiePreferences', { marketing: false, analytics: false }, { path: '/' });
//   };

//   const handleSavePreferences = () => {
//     setCookie('cookieConsent', 'custom', { path: '/', maxAge: 365 * 24 * 60 * 60 });
//     setCookie('cookiePreferences', preferences, { path: '/' });
//   };

//   return (
//     <div style={styles.overlay}>
//       <div style={styles.banner}>
        
//         {!showPreferences ? (
//           // --- Main Banner ---
//           <>
//             <h3 style={styles.title}>We value your privacy</h3>
//             <p style={styles.text}>
//               We use cookies and other technologies to personalize your experience,
//               perform marketing, and collect analytics. Learn more in our{' '}
//               <a href="/cookie-policy" style={styles.link}>Cookie Policy</a>.
//             </p>
//             <div style={styles.buttonGroup}>
//               <button onClick={handleAccept} style={styles.btnOutline}>Accept</button>
//               <button onClick={handleDecline} style={styles.btnOutline}>Decline</button>
//               <button onClick={() => setShowPreferences(true)} style={styles.btnText}>
//                 Preferences
//               </button>
//             </div>
//           </>
//         ) : (
//           // --- Preferences Panel ---
//           <>
//             <h3 style={styles.title}>Cookie Preferences</h3>

//             <div style={styles.preferenceItem}>
//               <div>
//                 <strong style={{ color: '#fff' }}>Necessary</strong>
//                 <p style={styles.prefDesc}>Required for the website to function. Cannot be disabled.</p>
//               </div>
//               <input type="checkbox" checked disabled  style={styles.input}/>
//             </div>

//             <div style={styles.preferenceItem}>
//               <div>
//                 <strong style={{ color: '#fff' }}>Marketing</strong>
//                 <p style={styles.prefDesc}>Used for personalized ads.</p>
//               </div>
//               <input style={styles.input}
//                 type="checkbox"
//                 checked={preferences.marketing}
//                 onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
//               />
//             </div>

//             <div style={styles.preferenceItem}>
//               <div>
//                 <strong style={{ color: '#fff' }}>Analytics</strong>
//                 <p style={styles.prefDesc}>Helps us understand how you use the site.</p>
//               </div>
//               <input style={styles.input}
//                 type="checkbox"
//                 checked={preferences.analytics}
//                 onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
//               />
//             </div>

//             <div style={styles.buttonGroup}>
//               <button onClick={handleSavePreferences} style={styles.btnOutline}>Save Preferences</button>
//               <button onClick={() => setShowPreferences(false)} style={styles.btnText}>Back</button>
//             </div>
//           </>
//         )}

//       </div>
//     </div>
//   );
// }

// // --- Styles ---
// const styles = {
//   overlay: {
//     position: 'fixed',
//     bottom: '5px',
//     right: '5px',
//     zIndex: 9999,
//   },
//   banner: {
//     backgroundColor: '#153ac9',
//     color: '#ccc',
//     padding: '24px',
//     borderRadius: '12px',
//     maxWidth: '380px',
//     boxShadow: '0 4px 20px rgba(0,0,0,0.5)',
//   },
//   title: {
//     color: '#ffffff',
//     marginBottom: '10px',
//     fontSize: '16px',
//   },
//   text: {
//     fontSize: '13px',
//     lineHeight: '1.6',
//     marginBottom: '16px',
//   },
//   link: {
//     color: '#fff',
//     textDecoration: 'underline',
//   },
//   buttonGroup: {
//     display: 'flex',
//     gap: '10px',
//     alignItems: 'center',
//     flexWrap: 'wrap',
//     marginTop: '12px',
//   },
//   btnOutline: {
//     backgroundColor: 'transparent',
//     color: '#fff',
//     border: '1px solid #fff',
//     borderRadius: '20px',
//     padding: '8px 18px',
//     cursor: 'pointer',
//     fontSize: '13px',
//   },
//   btnText: {
//     backgroundColor: 'transparent',
//     color: '#fff',
//     border: 'none',
//     textDecoration: 'underline',
//     cursor: 'pointer',
//     fontSize: '13px',
//   },
//   preferenceItem: {
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'flex-start',
//     marginBottom: '14px',
//     gap: '10px',
//   },
//   prefDesc: {
//     fontSize: '12px',
//     color: '#aaa',
//     margin: '2px 0 0 0',
//   },
//   input: {
//   height:"1rem",
//   width:"1rem"
//   },
// };

// export default CookieConsent;

import React, { useState } from 'react';
import { useCookies } from 'react-cookie';

function CookieConsent() {
  const [cookies, setCookie] = useCookies(['cookieConsent']);
  const [showPreferences, setShowPreferences] = useState(false);
  const [preferences, setPreferences] = useState({
    marketing: false,
    analytics: false,
  });

  if (cookies.cookieConsent) return null;

  const handleAccept = () => {
    setCookie('cookieConsent', 'accepted', { path: '/', maxAge: 365 * 24 * 60 * 60 });
    setCookie('cookiePreferences', { marketing: true, analytics: true }, { path: '/' });
  };

  const handleDecline = () => {
    setCookie('cookieConsent', 'declined', { path: '/', maxAge: 365 * 24 * 60 * 60 });
    setCookie('cookiePreferences', { marketing: false, analytics: false }, { path: '/' });
  };

  const handleSavePreferences = () => {
    setCookie('cookieConsent', 'custom', { path: '/', maxAge: 365 * 24 * 60 * 60 });
    setCookie('cookiePreferences', preferences, { path: '/' });
  };

  return (
    <>
      <style>{`
        .ck-overlay {
          position: fixed;
          bottom: 0;
          left: 0;
          width: 100%;
          z-index: 99999;
          background: #153ac9;
          box-shadow: 0 -4px 24px rgba(0,0,0,0.25);
          animation: ckSlideUp 0.4s cubic-bezier(0.16,1,0.3,1);
        }

        @keyframes ckSlideUp {
          from { transform: translateY(100%); opacity: 0; }
          to   { transform: translateY(0);    opacity: 1; }
        }

        .ck-banner {
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 24px;
          padding: 20px 40px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .ck-text {
          flex: 1;
          font-size: 13px;
          line-height: 1.65;
          color: #dce8ff;
          margin: 0;
        }

        .ck-text a {
          color: #fff;
          font-weight: 700;
          text-decoration: underline;
        }

        .ck-actions {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-shrink: 0;
        }

        .ck-btn-settings {
          background: transparent;
          border: none;
          color: #fff;
          font-size: 13px;
          font-weight: 600;
          text-decoration: underline;
          cursor: pointer;
          white-space: nowrap;
          padding: 0 4px;
        }

        .ck-btn-reject {
          background: transparent;
          color: #fff;
          border: 2px solid #fff;
          border-radius: 4px;
          padding: 10px 22px;
          font-size: 13px;
          font-weight: 600;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s, color 0.2s;
        }
      
        .ck-btn-accept {
          color: #fff;
          background: #153ac9;
          border: 2px solid #fff;
          border-radius: 4px;
          padding: 10px 22px;
          font-size: 13px;
          font-weight: 700;
          cursor: pointer;
          white-space: nowrap;
          transition: background 0.2s, color 0.2s;
        }
       
        .ck-prefs {
          padding: 24px 40px;
          max-width: 1400px;
          margin: 0 auto;
        }

        .ck-prefs-title {
          color: #fff;
          font-size: 16px;
          font-weight: 700;
          margin: 0 0 16px 0;
        }

        .ck-pref-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 10px 0;
          border-bottom: 1px solid rgba(255,255,255,0.15);
          gap: 16px;
        }
        .ck-pref-row:last-of-type { border-bottom: none; }

        .ck-pref-label {
          font-size: 14px;
          font-weight: 600;
          color: #fff;
          margin: 0 0 2px 0;
        }
        .ck-pref-desc {
          font-size: 12px;
          color: #aac0f5;
          margin: 0;
        }

        .ck-toggle {
          position: relative;
          width: 42px; height: 24px;
          flex-shrink: 0;
        }
        .ck-toggle input { opacity: 0; width: 0; height: 0; }
        .ck-toggle-slider {
          position: absolute; inset: 0;
          background: rgba(255,255,255,0.25);
          border-radius: 24px;
          cursor: pointer;
          transition: 0.25s;
          border: 1px solid rgba(255,255,255,0.3);
        }
        .ck-toggle-slider::before {
          content: '';
          position: absolute;
          width: 17px; height: 17px;
          left: 3px; top: 3px;
          background: #fff;
          border-radius: 50%;
          transition: 0.25s;
        }
        .ck-toggle input:checked + .ck-toggle-slider {
          background: #22c55e;
          border-color: #22c55e;
        }
        .ck-toggle input:checked + .ck-toggle-slider::before {
          transform: translateX(18px);
        }
        .ck-toggle input:disabled + .ck-toggle-slider { opacity: 0.6; cursor: not-allowed; }

        .ck-prefs-actions {
          display: flex;
          gap: 12px;
          margin-top: 20px;
          flex-wrap: wrap;
        }

        @media (max-width: 768px) {
          .ck-banner {
            flex-direction: column;
            align-items: flex-start;
            padding: 16px 20px;
            gap: 16px;
          }
          .ck-actions {
            width: 100%;
            flex-direction:column;
            gap:1.5rem;
          }
          .ck-prefs { padding: 16px 20px; }
          .ck-prefs-actions { justify-content: flex-end; }
          .ck-btn-settings{
          padding:0.5rem 0;
          font-size:1rem
          }
          .ck-btn-accept,.ck-btn-reject{
          width:100%;
          }
        }
      `}</style>

      <div className="ck-overlay">

        {!showPreferences ? (
          /* ── Main Banner ── */
          <div className="ck-banner">
            <p className="ck-text">
              By clicking “Accept All Cookies,” you consent to the use of first- and third-party cookies on your device to improve website functionality, analyze traffic and performance, and provide relevant content. You also acknowledge that your personal data may be processed in US, India and Europe, where necessary, transferred to trusted service providers in other countries for operational purposes. Such transfers are carried out in accordance with applicable data protection laws and appropriate safeguards. For more details, please review our <a href="/privacy-policy">Cookie Policy</a>.
            </p>
            <div className="ck-actions">
              <button className="ck-btn-settings" onClick={() => setShowPreferences(true)}>
                Cookies Settings
              </button>
              <button className="ck-btn-reject" onClick={handleDecline}>
                Reject All
              </button>
              <button className="ck-btn-accept" onClick={handleAccept}>
                Accept All Cookies
              </button>
            </div>
          </div>
        ) : (
          /* ── Preferences Panel ── */
          <div className="ck-prefs">
            <h3 className="ck-prefs-title">Cookie Preferences</h3>

            <div className="ck-pref-row">
              <div>
                <p className="ck-pref-label">Necessary</p>
                <p className="ck-pref-desc">Required for the website to function. Cannot be disabled.</p>
              </div>
              <label className="ck-toggle">
                <input type="checkbox" checked disabled />
                <span className="ck-toggle-slider" />
              </label>
            </div>

            <div className="ck-pref-row">
              <div>
                <p className="ck-pref-label">Marketing</p>
                <p className="ck-pref-desc">Used for personalized ads.</p>
              </div>
              <label className="ck-toggle">
                <input
                  type="checkbox"
                  checked={preferences.marketing}
                  onChange={(e) => setPreferences({ ...preferences, marketing: e.target.checked })}
                />
                <span className="ck-toggle-slider" />
              </label>
            </div>

            <div className="ck-pref-row">
              <div>
                <p className="ck-pref-label">Analytics</p>
                <p className="ck-pref-desc">Helps us understand how you use the site.</p>
              </div>
              <label className="ck-toggle">
                <input
                  type="checkbox"
                  checked={preferences.analytics}
                  onChange={(e) => setPreferences({ ...preferences, analytics: e.target.checked })}
                />
                <span className="ck-toggle-slider" />
              </label>
            </div>

            <div className="ck-prefs-actions">
              <button className="ck-btn-settings" onClick={() => setShowPreferences(false)}>
                ← Back
              </button>
              <button className="ck-btn-reject" onClick={handleDecline}>
                Reject All
              </button>
              <button className="ck-btn-accept" onClick={handleSavePreferences}>
                Save Preferences
              </button>
            </div>
          </div>
        )}

      </div>
    </>
  );
}

export default CookieConsent;